import { render, staticRenderFns } from "./ModalInibirRestricoesEmLote.vue?vue&type=template&id=518a8ae2&lang=pug"
import script from "./ModalInibirRestricoesEmLote.vue?vue&type=script&lang=js"
export * from "./ModalInibirRestricoesEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalInibirRestricoesEmLote.vue?vue&type=style&index=0&id=518a8ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports